<template>
    <div style="padding: 10px 10px 10px 0;">
        <el-dialog :title="title" :visible.sync="show" width="30%">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="所属楼层">
                    <el-select :disabled="title[0] == '查'" v-model="form.storey" placeholder="所属楼层">
                        <el-option v-for="item in 5" :label="`${item}楼`" :value="`${item}楼`"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input :disabled="title[0] == '查'" v-model="form.linkName"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input :disabled="title[0] == '查'" v-model="form.linkPhone"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input :disabled="title[0] == '查'" v-model="form.linkCard"></el-input>
                </el-form-item>
                <el-form-item label="商铺状态">
                    <el-select :disabled="title[0] == '查'" v-model="form.status">
                        <el-option label="正常" value="正常"></el-option>
                        <el-option label="停用" value="停用"></el-option>
                </el-select>
    
                </el-form-item>
                <el-form-item label="水仪表编码">
                    <el-input :disabled="title[0] == '查'" v-model="form.waterCode"></el-input>
                </el-form-item>
                <el-form-item label="电仪表编码">
                    <el-input :disabled="title[0] == '查'" v-model="form.electricityCode"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                            <el-button @click="show = false">取 消</el-button>
                            <el-button v-if="title[0] != '查'" type="primary" @click="ok">确 定</el-button>
                        </span>
        </el-dialog>
    
    
        <el-form :inline="true" :model="selectForm" class="demo-form-inline">
            <div class="flex sb">
                <div>
                    <el-form-item label="商铺号">
                        <el-select filterable size="small" v-model="selectForm.shopNum" placeholder="请选择商铺号" clearable style="width: 150px;">
                            <el-option v-for="item in shopList" :label="item.shopNum" :value="item.shopNum"></el-option>
                        </el-select>
                        <!-- <el-input size="small" v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input> -->
                    </el-form-item>
                    <!-- <el-form-item label="对账状态">
                                    <el-select size="small"  v-model="selectForm.status">
                                        <el-option label="未对账" value="1"></el-option>
                                        <el-option label="已对账" value="2"></el-option>
                                    </el-select>
                                </el-form-item> -->
                    <el-form-item label="付款方名称">
                        <el-input size="small" v-model="selectForm.name" placeholder="付款方名称" clearable></el-input>
                    </el-form-item>
                         <el-form-item label="是否关联店铺">
                           <el-select size="small" filterable v-model="selectForm.isRelevance" placeholder="请选择是否" clearable>
                            <el-option  :label="'全部'" :value="null"></el-option>
                              <el-option  :label="'是'" :value="'1'"></el-option>
                              <el-option  :label="'否'" :value="'0'"></el-option>
                          </el-select>
                    </el-form-item>
                    <el-form-item label="是否修订">
                           <el-select size="small" filterable v-model="selectForm.isModify" placeholder="请选择是否" clearable>
                            <el-option  :label="'全部'" :value="null"></el-option>
                              <el-option  :label="'已修订'" :value="'1'"></el-option>
                              <el-option  :label="'无修订'" :value="'0'"></el-option>
                          </el-select>
                    </el-form-item>
                    <el-form-item label="交易日期">
                        <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="selectForm.startTime" type="date" placeholder="开始时间" style="width: 150px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="-">
                        <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="selectForm.endTime" type="date" placeholder="结束时间" style="width: 150px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="query()">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="addTemplate">下载对账单导入模板</el-button>
                    </el-form-item>
    
                    <el-form-item>
                        <el-upload action="/api/admin/reconciliation/importReconciliation" name="file" :show-file-list="false" :headers="headers" :on-success="success">
                            <el-button size="small" type="primary">导入对账单</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="dc">导出</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
            						<el-button type="primary" @click="addTemplate">下载对账单导入模板</el-button>
            					</el-form-item>
            
            					<el-form-item>
            						<el-upload action="/api/admin/reconciliation/importReconciliation" name="file"
            							:show-file-list="false" :headers="headers" :on-success="success">
            							<el-button type="primary">导入对账单</el-button>
            						</el-upload>
            					</el-form-item>
            
            					<el-form-item>
            						<el-button type="primary" @click="dc2">下载历史开票信息</el-button>
            					</el-form-item>
            					<el-form-item>
            						<el-button type="primary" @click="dc3">下载未开票信息</el-button>
            					</el-form-item> -->
                </div>
    
            </div>
            <div>{{ sum }}</div>
        </el-form>
        <el-table v-loading="loading" :data="data" style="width: 100%" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55">
                        </el-table-column> -->
            <el-table-column prop="shopNum" label="商铺编号" align="center"></el-table-column>
            <el-table-column prop="accountId" label="付款方账号" align="center"></el-table-column>
            <el-table-column prop="name" label="付款方名称" align="center"></el-table-column>
            <el-table-column prop="serialNum" label="交易流水号" align="center"></el-table-column>
    
            <el-table-column prop="dateTimes" label="交易日期" align="center"></el-table-column>
            <el-table-column prop="amount" label="银行流水金额" align="center"></el-table-column>
            <el-table-column prop="isModify" label="修订状态"  align="center">
              <template slot-scope="{row}">
                {{ row.isModify==1?'已修订':'无修订' }}
              </template>
            </el-table-column>
            <el-table-column prop="afterModifyAmount" label="修订金额"  align="center"></el-table-column>
            <el-table-column prop="remark" label="修订备注"  align="center"></el-table-column>
            <el-table-column label="操作" width="170"  align="center">
            <template slot-scope="{row}">
                <el-button type="text" @click="setRow(row)">绑定</el-button>
                <el-button type="text" @click="setRowInfo(row)">修订</el-button>
            </template>
			</el-table-column>
        </el-table>
        <el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.pageSize"
        :current-page="selectForm.currentPage"
            layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>


        <el-dialog title="编辑" :visible.sync="show2" width="400px" :close-on-click-modal="false">

            <span>商铺号：</span>
            <el-select filterable v-model="shopNumChange" placeholder="请选择商铺号" clearable>
                 <el-option v-for="item in shopList" :label="item.shopNum" :value="item.shopNum"></el-option>
                 <!-- <el-option  :label="'其他'" :value="''"></el-option> -->
            </el-select>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="show2 = false">取 消</el-button>
                    <el-button type="primary" @click="okChage">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title2 + '-金额修订'" :visible.sync="show3" width="450px" :close-on-click-modal="false">

          <el-form ref="form"  label-width="100px">
                <el-form-item label="修改前金额：">
                  <el-input style="width:250px;" v-model="oldMoney"  placeholder="请输入修改前金额" readonly></el-input>
                  </el-form-item>
                <el-form-item label="修改后金额：">
                  <el-input  style="width:250px;"  v-model="editMoney" placeholder="请输入修改后金额"></el-input>
                  </el-form-item>
                <el-form-item label="备注：">
                  <el-input  style="width:250px;"  v-model="editRemark" placeholder="请输入备注"
                  type="textarea"></el-input>
                  </el-form-item>
          </el-form>
              <span slot="footer" class="dialog-footer">
                        <el-button @click="show3 = false">取 消</el-button>
                        <el-button type="primary" @click="okEdit">确 定</el-button>
              </span>
        </el-dialog>

        <el-dialog title="导入提示" :visible.sync="messageShow" width="700px" :close-on-click-modal="false">
            <div style="color:red">*以下账号第一次付款，请先至商铺信息，进行账户关联再重新导入！</div>
            <div>{{ messageData }}</div>
        </el-dialog>

        <el-dialog title="以下数据交易流水号已存在" :visible.sync="isFail">
            <div style="margin-bottom: 30px;">
                <el-table :data="czList" style="width: 100%" max-height="500">
                    <el-table-column prop="serialNum" label="交易流水号" align="center"></el-table-column>
                    <el-table-column prop="shopNum" label="商铺编号" align="center"></el-table-column>
                    <el-table-column prop="accountId" label="付款方账号" align="center"></el-table-column>
                    <el-table-column prop="name" label="付款方名称" align="center"></el-table-column>
                    <el-table-column prop="dateTimes" label="交易日期" align="center"></el-table-column>
                    <el-table-column prop="amount" label="实缴金额" align="center"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
import xtdzDetail from "./xtdzDetail.vue";

export default {
  // 注册组件
  components: {
    xtdzDetail,
  },
  data() {
    return {
      oldMoney: 0,
      editMoney: "",
      editRemark: "",
      shopNumChange: "",
      shopList: [],
      loading: false,
      messageShow: false,
      activeName: "1",
      data2: [],
      obj: {},
      show2: false,
      title: "新增",
      count: 0,
      count2: 0,
      sum: "",
      headers: {
        Authorization: localStorage.access_token,
      },
      title2: "",
      show: false,
      selectForm: {
        isRelevance: null,
        isModify: null,
        name: null,
        currentPage: 1,
        pageSize: 10,
        shopNum: null, //商铺号
        startTime: null, //楼层
        endTime: null,
        state: null,
      },
      selectForm2: {
        page: 1,
        row: 10,
        shopNum: null, //商铺号
        startTime: null,
        endTime: null,
        type: null,
        isInvoice: null,
      },
      oldForm: "",
      loading2: false,
      form: {
        storey: "", //楼层
        linkName: "",
        linkPhone: "",
        linkCard: "",
        status: "",
        waterCode: "",
        electricityCode: "",
      },
      data: [],
      isFail: false,
      czList: [],
      paymentBillVos: [],
      show3: false,
      messageData: "",
    };
  },
  methods: {
    okEdit() {
      // oldMoney:0,
      // editMoney:0,
      // editRemark:"",
      if (!this.editMoney) {
        this.$message.error("请输入金额");
        return;
      }
      if (!this.editRemark) {
        this.$message.error("请输入备注");
        return;
      }
      let data = {};
      if (this.obj.isModify == "1") {
        data = {
          id: this.obj.id,
          shopNum: this.obj.shopNum,
          afterModifyAmount: this.editMoney,
          remark: this.editRemark,
          isModify: this.obj.isModify,
        };
      } else {
        data = {
          id: this.obj.id,
          shopNum: this.obj.shopNum,
          afterModifyAmount: this.editMoney,
          remark: this.editRemark,
        };
      }
      this.$http
        .post("/api/bdShop/updateAmount", data)
        .then((res) => {
          if (res.data.code == 0) {
            this.show3 = false;
            this.getAll();
            this.$message.success("修改成功！");
            if(this.obj.shopNum){
              this.calculateDifference(this.obj.shopNum);
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {});
    },
    okChage() {
      // alert(this.shopNumChange);
      // this.show2 = false;
      // return;
      // this.shopNumChange
      if(this.shopNumChange!==this.obj.shopNum){
        this.$http
        .post("/api/bdShop/insertShopAccount", {
          id: this.obj.id,
          accountId: this.obj.accountId,
          accountName: this.obj.name,
          shopNum: this.shopNumChange,
          oldShopNum: this.obj.shopNum,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.show2 = false;
            this.getAll();
            this.$message.success("操作成功！");
            this.calculateDifference(this.obj.shopNum);
            if(this.shopNumChange){
              this.calculateDifference(this.shopNumChange);
            }
          } else {
            this.$message.error("操作失败！");
          }
        })
        .catch((err) => {});
      }else{
        this.show2 = false;
      }
      
    },
    query() {
      this.selectForm.currentPage = 1;
      this.getAll();
    },
    getShopList() {
      let selectForm = {
        currentPage: 1,
        pageSize: 1000,
      };
      this.$http.post("/api/bdShop/queryShop", selectForm).then((res) => {
        this.shopList = res.data.data.items;
      });
    },
    handleSelectionChange(val) {
      this.paymentBillVos = val;
    },
    tb() {
      this.$http
        .post("/api/shop/code/init", {})
        .then((res) => {
          if (res.data.code == 0) {
            this.getAll();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {});
    },
    addTemplate() {
      //下载导入模板
      this.$http
        .post(
          `/api/reconciliation/downloadReconciliationTemplate`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "对账单导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    success(res) {
      if (res.code == 0) {
        console.log(res);
        this.getAll();
        if (res.data != "") {
          this.messageData = res.data;
          this.messageShow = true;
        } else {
          this.$message.success("导入成功");
        }
      } else {
        this.$message.error(res.message);
        this.isFail = true;
        this.czList = res.data;
      }
    },
    setRowInfo(obj) {
      this.title2 = obj.name;
      this.oldMoney = obj.amount;
      this.editMoney = obj.afterModifyAmount;
      this.editRemark = obj.remark;
      this.obj = obj;
      this.show3 = true;
    },
    query22() {
      this.selectForm2.page = 1;
      this.getData2();
    },
    query2() {
      this.selectForm2.page = 1;
      this.selectForm2.row = 10;
      this.selectForm2.startTime = null;
      this.selectForm2.endTime = null;
      this.selectForm2.type = null;
      this.selectForm2.isInvoice = null;
      this.getData2();
    },
    getData2() {
      this.loading2 = true;
      this.$http
        .post("/api/reconciliation/reconciliationList", this.selectForm2)
        .then((res) => {
          this.loading2 = false;
          this.data2 = res.data.data.items;
          this.count2 = res.data.data.totalNum;
        });
    },
    setRow(obj) {
      this.obj = obj;
      this.shopNumChange = obj.shopNum;
      this.show2 = true;
      // this.$router.push({
      // 	name:'系统对账详情',
      // 	params:{
      // 		obj
      // 	}
      // })
    },
    dc() {
      publicExport("/api/reconciliation/export", this.selectForm, "实缴费用");
    },
    dc2() {
      console.log(this.paymentBillVos);
      if (this.paymentBillVos.length == 0) {
        this.$message.error("请勾选需要下载历史开票信息的数据！");
        return;
      }
      let ids = [];
      this.paymentBillVos.forEach((element) => {
        ids.push(element.id);
      });
      publicExport(
        "/api/reconciliation/exportInvoice",
        { ids: ids.toString() },
        "历史开票信息"
      );
    },
    dc3() {
      publicExport("/api/reconciliation/exportInvoice", {}, "开票信息");
    },
    ok() {
      let url = "/api/bdShop/addShop";
      if (this.title == "编辑") {
        url = "/api/bdShop/updateShop";
      }
      this.$http.post(url, this.form).then((res) => {
        if (res.data.code == 0) {
          this.getAll();
          this.show = false;
          this.$message.success(`${this.title}成功`);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    addRow() {
      this.form = JSON.parse(JSON.stringify(this.oldForm));
      this.title = "新增";
      this.show = true;
    },
    getAll() {
      this.loading = true;
      if (this.selectForm.isRelevance == "") {
        this.selectForm.isRelevance = null;
      }
      if (this.selectForm.isModify == "") {
        this.selectForm.isModify = null;
      }
      this.$http
        .post("/api/reconciliation/query", this.selectForm)
        .then((res) => {
          this.data = res.data.data.items;
          this.count = res.data.data.totalNum;
          this.sum = res.data.data.sum
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.selectForm.currentPage = val;
      this.getAll();
    },

    handleSizeChange(val) {
      this.selectForm.pageSize = val;
      this.getAll();
    },
    handleCurrentChange2(val) {
      this.selectForm2.page = val;
      this.getData2();
    },
    handleSizeChange2(val) {
      this.selectForm2.row = val;
      this.getData2();
    },
  },
  created() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    this.getShopList();
    this.getAll();
  },
};
</script>

<style scoped="scoped">
</style>
